export default "__VITE_ASSET__BwsSzotW__"